/**
 * Global Toast
 *
 * Renders the ValidationToast using the global ToastContext.
 * Place once in the app tree (e.g., App.tsx).
 */

import React from 'react';
import { useToast } from '../../context/ToastContext';
import { ValidationToast } from './ValidationToast';

export const GlobalToast: React.FC = () => {
  const { toastMessage, toastVariant, dismissToast } = useToast();
  return <ValidationToast message={toastMessage} variant={toastVariant} onDismiss={dismissToast} />;
};
